<comp-dialog>
  <ng-container comp-dialog-header-title>{{ 'askAnExpert.singular' | translate }}</ng-container>
  <ng-container comp-dialog-content>
    <form id="ask-an-expert" [formGroup]="form" (ngSubmit)="onSubmit()">
      @if (data.requirement) {
        <p>
          {{ 'askAnExpert.currentRequirementPrefix' | translate }}
          <em>{{ data.requirement?.name }}</em>
        </p>
      }
      @if (!submitting()) {
        <mat-form-field appearance="outline" [floatLabel]="'always'" class="outlined-form-element">
          <mat-label>{{ 'askAnExpert.question' | translate }}</mat-label>
          <textarea
            compAutofocus
            [formControlName]="'question'"
            matInput
            required
            class="outlined-form-element textarea large"
          ></textarea>
        </mat-form-field>
      } @else {
        <mat-spinner diameter="24"></mat-spinner>
      }
    </form>
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" mat-dialog-close>
          {{ 'general.cancel' | translate }}
        </button>
        <button
          comp-button
          type="submit"
          form="ask-an-expert"
          [disabled]="form.invalid || submitting()"
        >
          {{ 'general.send' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons></ng-container
  >
</comp-dialog>
